// extracted by mini-css-extract-plugin
export default {"card":"Process_card__4BtOc","col_left":"Process_col_left__VGP2l","col_right":"Process_col_right__fnDRa","text":"Process_text__xLtuF"};